// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#sat-info-title {
  font-size: 16px !important;
  min-height: 20px;
  height: auto;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-around;
  align-items: center;
  padding: 2px 0;
  text-align: center;
  background: var(--color-dark-border);
  color: var(--colorWhite);
}

.sat-watchlist-icon {
  width: 18px;
  height: 18px;
  cursor: pointer;
  transition: filter 0.2s ease, transform 0.15s ease;
}

.sat-watchlist-icon:hover {
  transform: scale(1.15);
}

.sat-watchlist-icon.off-watchlist {
  filter: brightness(0) invert(1) opacity(0.6);
}

.sat-watchlist-icon.on-watchlist {
  filter: invert(52%) sepia(130%) saturate(7323%) hue-rotate(120deg) brightness(100%) contrast(86%);
}

.sat-info-section-header {
  height: 20px;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 0 16px;
  background: var(--color-dark-border);
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  border-top: 1px solid var(--color-dark-background);
}

.sat-info-section-header:hover {
  background: color-mix(in srgb, var(--color-dark-border) 85%, white);
}

#sat-infobox a {
  color: white;
}

.sat-info-row {
  padding: 2px 6px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  border-radius: var(--kt-radius-sm, 4px);
  transition: background-color var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));
}

.sat-info-row:hover {
  background: var(--kt-bg-hover, rgba(255, 255, 255, 0.08));
}

#sat-site {
  max-height: 32px;
}

#sat-site-row {
  max-height: 32px;
}

.sat-info-key,
.sat-info-value {
  display: inline-block;
}

.sat-info-key {
  max-width: 80px;
  font-size: 11px;
  line-height: 1.3;
  color: white;
  float: left;
}

.sat-infobox-links {
  font-size: 11px;
  padding: 1px 6px;
  color: var(--color-dark-text-accent);
}

.section-collapse {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.4);
  cursor: pointer;
  flex-shrink: 0;
  transition: transform var(--kt-duration-normal, 200ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));
}

.collapsed .section-collapse {
  transform: rotate(-90deg);
}

.sat-info-section,
#sat-identifier-data,
#orbital-section,
#secondary-sat-info,
#sensor-sat-info,
#sat-mission-data {
  transition: max-height 0.5s ease-in-out;
  max-height: 1000px;
  /* Set this to a value larger than the content's height */
  overflow: hidden;
  margin: 0px;
}

.sat-info-section.collapsed,
#sat-identifier-data.collapsed,
#orbital-section.collapsed,
#secondary-sat-info.collapsed,
#sensor-sat-info.collapsed,
#doppler-sat-info.collapsed,
#sat-mission-data.collapsed {
  max-height: 20px;
  transition: max-height 0.2s ease-in-out;
  margin: 0px;
}

#sat-infobox {
  display: none;
  position: absolute;
  background: var(--color-dark-background);
  cursor: default;
  bottom: 0px;
  height: fit-content;
  max-height: 45%;
  width: 100%;
  border: 1px solid var(--kt-border-default, rgba(255, 255, 255, 0.12));
  border-top: 1px solid var(--kt-border-default, rgba(255, 255, 255, 0.12));
  box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.4);
  overflow-y: auto;
  scrollbar-gutter: auto;
  z-index: 10000;
}

.sat-info-value {
  float: right;
  width: 45%;
  min-height: 16px;
  font-size: 12px;
  line-height: 1.3;
  text-overflow: ellipsis;
  overflow: hidden;
}

/* Click-to-copy affordance on identifier values (NORAD / COSPAR) */
.sat-info-copyable {
  cursor: copy;
}

.sat-info-copyable:hover {
  color: var(--color-dark-text-accent);
  text-decoration: underline dotted;
}
`, "",{"version":3,"sources":["webpack://./src/plugins/sat-info-box/sat-info-box.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,iGAAiG;AACnG;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,oCAAoC;EACpC,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kDAAkD;EAClD,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,uCAAuC;EACvC,kHAAkH;AACpH;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,eAAe;EACf,cAAc;EACd,6GAA6G;AAC/G;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;;EAME,uCAAuC;EACvC,kBAAkB;EAClB,yDAAyD;EACzD,gBAAgB;EAChB,WAAW;AACb;;AAEA;;;;;;;EAOE,gBAAgB;EAChB,uCAAuC;EACvC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,qEAAqE;EACrE,yEAAyE;EACzE,0CAA0C;EAC1C,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,mEAAmE;AACnE;EACE,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;AACnC","sourcesContent":["#sat-info-title {\n  font-size: 16px !important;\n  min-height: 20px;\n  height: auto;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: space-around;\n  align-items: center;\n  padding: 2px 0;\n  text-align: center;\n  background: var(--color-dark-border);\n  color: var(--colorWhite);\n}\n\n.sat-watchlist-icon {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n  transition: filter 0.2s ease, transform 0.15s ease;\n}\n\n.sat-watchlist-icon:hover {\n  transform: scale(1.15);\n}\n\n.sat-watchlist-icon.off-watchlist {\n  filter: brightness(0) invert(1) opacity(0.6);\n}\n\n.sat-watchlist-icon.on-watchlist {\n  filter: invert(52%) sepia(130%) saturate(7323%) hue-rotate(120deg) brightness(100%) contrast(86%);\n}\n\n.sat-info-section-header {\n  height: 20px;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  padding: 0 16px;\n  background: var(--color-dark-border);\n  color: white;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n  border-top: 1px solid var(--color-dark-background);\n}\n\n.sat-info-section-header:hover {\n  background: color-mix(in srgb, var(--color-dark-border) 85%, white);\n}\n\n#sat-infobox a {\n  color: white;\n}\n\n.sat-info-row {\n  padding: 2px 6px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  align-items: center;\n  border-radius: var(--kt-radius-sm, 4px);\n  transition: background-color var(--kt-duration-fast, 100ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));\n}\n\n.sat-info-row:hover {\n  background: var(--kt-bg-hover, rgba(255, 255, 255, 0.08));\n}\n\n#sat-site {\n  max-height: 32px;\n}\n\n#sat-site-row {\n  max-height: 32px;\n}\n\n.sat-info-key,\n.sat-info-value {\n  display: inline-block;\n}\n\n.sat-info-key {\n  max-width: 80px;\n  font-size: 11px;\n  line-height: 1.3;\n  color: white;\n  float: left;\n}\n\n.sat-infobox-links {\n  font-size: 11px;\n  padding: 1px 6px;\n  color: var(--color-dark-text-accent);\n}\n\n.section-collapse {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.4);\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: transform var(--kt-duration-normal, 200ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));\n}\n\n.collapsed .section-collapse {\n  transform: rotate(-90deg);\n}\n\n.sat-info-section,\n#sat-identifier-data,\n#orbital-section,\n#secondary-sat-info,\n#sensor-sat-info,\n#sat-mission-data {\n  transition: max-height 0.5s ease-in-out;\n  max-height: 1000px;\n  /* Set this to a value larger than the content's height */\n  overflow: hidden;\n  margin: 0px;\n}\n\n.sat-info-section.collapsed,\n#sat-identifier-data.collapsed,\n#orbital-section.collapsed,\n#secondary-sat-info.collapsed,\n#sensor-sat-info.collapsed,\n#doppler-sat-info.collapsed,\n#sat-mission-data.collapsed {\n  max-height: 20px;\n  transition: max-height 0.2s ease-in-out;\n  margin: 0px;\n}\n\n#sat-infobox {\n  display: none;\n  position: absolute;\n  background: var(--color-dark-background);\n  cursor: default;\n  bottom: 0px;\n  height: fit-content;\n  max-height: 45%;\n  width: 100%;\n  border: 1px solid var(--kt-border-default, rgba(255, 255, 255, 0.12));\n  border-top: 1px solid var(--kt-border-default, rgba(255, 255, 255, 0.12));\n  box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.4);\n  overflow-y: auto;\n  scrollbar-gutter: auto;\n  z-index: 10000;\n}\n\n.sat-info-value {\n  float: right;\n  width: 45%;\n  min-height: 16px;\n  font-size: 12px;\n  line-height: 1.3;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n/* Click-to-copy affordance on identifier values (NORAD / COSPAR) */\n.sat-info-copyable {\n  cursor: copy;\n}\n\n.sat-info-copyable:hover {\n  color: var(--color-dark-text-accent);\n  text-decoration: underline dotted;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
